/**
 * Component Registry for Preferred 
 * 
 * Inherits from @vibesites-rebel-residential/theme-preferred and allows property-specific overrides.
 */

import type { ComponentRegistry } from '@vibesites/runtime';
import { registry as parentRegistry } from '@vibesites-rebel-residential/theme-preferred/registry';
import { Header } from './components/Header';
import { Footer } from './components/Footer';
import { ReviewsCallout } from './components/ReviewsCallout';

/**
 * Property-specific component overrides.
 * Uncomment and customize components as needed.
 */
const propertyOverrides: Partial<ComponentRegistry> = {
  Header,
  Footer,
  ReviewsCallout,
};

/**
 * Final merged registry for this property.
 * Inherits all components from the parent theme, with property overrides.
 */
export const registry: ComponentRegistry = {
  ...parentRegistry,
  ...propertyOverrides,
};

export default registry;
